import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { verifyCompanyEmail } from "actions/companyActions";
import Semi360Logo from "components/Semi360Logo";
import "./LoginPage.css";

// status: "verifying" | "success" | "error"
const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");
  const calledRef = useRef(false);

  useEffect(() => {
    // Guard against double-invocation (React 18 StrictMode) consuming the token twice.
    if (calledRef.current) return;
    calledRef.current = true;

    const run = async () => {
      if (!token) {
        setStatus("error");
        setMessage("Invalid verification link.");
        return;
      }
      try {
        const response = await verifyCompanyEmail(token);
        if (response?.status) {
          setStatus("success");
          setMessage(response.message || "Email verified successfully. You can now log in.");
        } else {
          setStatus("error");
          setMessage(response?.message || "We couldn't verify your email. The link may be invalid or expired.");
        }
      } catch (error) {
        setStatus("error");
        setMessage("Something went wrong while verifying your email. Please try again.");
      }
    };
    run();
  }, [token]);

  const isSuccess = status === "success";
  const isError = status === "error";

  return (
    <div className="sb-login-stage sb-dark" data-screen-label="Verify email">
      <div className="sb-shell" style={{ maxWidth: 460 }}>
        <div className="sb-brand-lockup">
          <Semi360Logo className="sb-brand-logo" />
        </div>

        <div className="sb-card" style={{ textAlign: "center" }}>
          {status === "verifying" && (
            <>
              <h1 style={{ fontSize: 24, lineHeight: "30px" }}>Verifying your email…</h1>
              <p className="sb-lede" style={{ marginTop: 8 }}>
                Please wait while we confirm your verification link.
              </p>
            </>
          )}

          {isSuccess && (
            <>
              <h1 style={{ fontSize: 24, lineHeight: "30px" }}>Email verified 🎉</h1>
              <p className="sb-lede" style={{ marginTop: 8 }}>{message}</p>
              <button
                type="button"
                className="sb-btn sb-btn-primary"
                style={{ marginTop: 8 }}
                onClick={() => navigate("/")}
              >
                Go to login
              </button>
            </>
          )}

          {isError && (
            <>
              <h1 style={{ fontSize: 24, lineHeight: "30px" }}>Verification failed</h1>
              <p className="sb-lede" style={{ marginTop: 8 }}>{message}</p>
              <button
                type="button"
                className="sb-btn sb-btn-primary"
                style={{ marginTop: 8 }}
                onClick={() => navigate("/")}
              >
                Back to login
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
